const index = () => import(/* webpackChunkName: "herb" */ './Index');

//2019年省级工业转型升级专项资金
export default {
  routes: [
    {
      path: '/guide/china/v2020/index',
      name: 'guide_china_v2020_index',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/guide/china/v2020/router.js